import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import CanvasDraw from 'react-canvas-draw';
import useGameState from '../../games/utils/use_game_state';
import Game from '../../games/Shared/Game';

const Drawing = ({ relatedGames, image }) => {
  const colors = ['#582b01', '#ffff00', '#f3cf95', '#fe0000', '#ff98cd', '#7c1679', '#ffffff', '#6ccff6', '#0d51b6', '#000000', '#006300'];
  const [brushColor, setBrushColor] = useState(colors[0]);
  const [eraser, setEraser] = useState(false);
  const [brushRadius, setBrushRadius] = useState(2);
  const [gameState] = useGameState();
  const pencilColor = brushColor.substring(1);

  return <Game gameState={gameState} relatedGames={relatedGames} assetPath={'/'} isApp={false}>
    <div className="max-h-screen m-auto flex items-center h-full p-1">
      <div className="flex flex-col gap-6 w-full mx-auto max-w-6xl h-full justify-center">
        <div className="flex w-full justify-between z-20 relative color-bar">
          {colors.map(color => <div key={color} onClick={() => { setEraser(false); setBrushColor(color); }} className="rounded-full border-white border-4 border-solid w-8 h-8 sm:w-10 sm:h-10 md:w-16 md:h-16 shadow" style={{ backgroundColor: color }} />)}
        </div>
        <div className="relative flex-col-reverse lg:flex-row landscape:flex-row flex inset-0 items-stretch landscape:overflow-y-hidden">
          <div className="flex-0 flex lg:space-y-8 items-center lg:items-end justify-around lg:justify-start lg:flex-col landscape:flex-col landscape:items-end">
            <div onClick={() => { setEraser(false); setBrushRadius(2); }} className={`transform translate-y-6 -rotate-90 lg:rotate-0 landscape:rotate-0 lg:transform-none ${brushRadius !== 2 || eraser ? 'opacity-50' : ''}`}>
              <img src={`/assets/crafts/drawing/${pencilColor}-sm.png`} alt="" />
            </div>
            <div onClick={() => { setEraser(false); setBrushRadius(8); }} className={`transform translate-y-6 -rotate-90 lg:rotate-0 lg:translate-0 landscape:rotate-0 landscape:translate-0 lg:transform-none ${brushRadius !== 8 || eraser ? 'opacity-50' : ''}`}>
              <img src={`/assets/crafts/drawing/${pencilColor}-lg.png`} alt="" />
            </div>
            <div onClick={() => { setEraser(true); }} className={`transform -rotate-90 lg:rotate-0 landscape:rotate-0 lg:transform-none ${!eraser ? 'opacity-50' : ''}`}>
              <img src="/assets/crafts/drawing/eraser.png" alt="" />
            </div>
          </div>
          <div className="flex-1 bg-white rounded-lg overflow-hidden">
            <div className="relative" style={{ paddingBottom: '56%' }}>
              <img className="absolute object-contain h-full w-full m-auto" src={image} alt="Kleurplaat" style={{ pointerEvents: 'none', zIndex: 20 }}/>
              <div className="absolute inset-0 max-h-full m-auto">
                <CanvasDraw
                  hideGrid={true}
                  brushColor={eraser ? '#ffffff' : brushColor}
                  catenaryColor={eraser ? '#ffffff' : brushColor}
                  brushRadius={eraser ? 8 : brushRadius}
                  canvasWidth="100%"
                  canvasHeight="100%"
                  lazyRadius={0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Game>;
};

const data = document.querySelector('#drawing').dataset;
const props = {
  image: data.image,
  relatedGames: JSON.parse(data.related),
};
ReactDOM.render(<Drawing {...props} />, document.querySelector('#drawing'));
